var map = {
	"./Appoinment.png": 2078,
	"./Close_Leads.png": 8339,
	"./Customer_List.png": 4680,
	"./Dealers_List.png": 5330,
	"./Reports.png": 1938,
	"./Statistics_Charts_1.jpeg": 1305,
	"./Statistics_Charts_2.jpeg": 2568,
	"./Transactions.png": 3704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2086;